import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-view-panel',
  templateUrl: './view-panel.component.html',
  styleUrls: ['./view-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewPanelComponent implements OnInit {
  @Input()
  label = '';

  @Input()
  showHeader = true;

  @Input()
  padding: 'none' | 'dense' | 'normal' = 'normal';

  constructor() { }

  ngOnInit() {
  }

}
